import PropTypes from 'prop-types';
import React from 'react';

const Legal = (props) => {
    if (!props.data) {
        return null;
    }

    const copyright = props.data.copyright;
    const terms = props.data.termsAndConditions;

    return (
        <div className="SiteFooterLegal text-muted">
            {terms &&
                <p
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: terms
                    }}
                />
            }
            {copyright &&
                <p>{copyright}</p>
            }
        </div>
    );
};

Legal.propTypes = {
    data: PropTypes.shape({
        copyright: PropTypes.string,
        termsAndConditions: PropTypes.string
    })
};

export default Legal;
